import styled from '@emotion/styled'

export const QuestionContainer = styled.div`
    & > *:only-child[data-role='questionnaire-divider'] {
        display: none;
    }
`
